import { getCurrentParams } from "modules/PsyCatalog/common/utils"

export interface CurrentFilter {
    get: () => string | undefined
}

function get() {
    const params = getCurrentParams()
    if (!params) return ""
    if ("filter" in params && typeof params.filter === "string") {
        return params.filter
    }
    return ""
}

export const CurrentFilter = { get }
